import { formatAccountNumber } from '@eika-infrastruktur/format';

import { numberFormat } from '../components/shared/numberFormat';
import type { Account, AccountOwner, Currency } from '../generated-types';
import { getRelevantOwner } from '../utils/mapper/accountSorter';

export const accessibleCurrency = (value: number, currency: Currency, fractals = 2): string => {
    try {
        const locale = window.navigator.language || 'nb-NO';
        const formattedNumber = numberFormat(value, fractals, locale);
        const isNorsk = currency === 'NOK' && (locale === 'nb-NO' || locale === 'nb-NN');

        if (isNorsk) {
            const unitsSubUnitsArray = formattedNumber.split(/[,.]/);

            if (unitsSubUnitsArray && unitsSubUnitsArray.length === 2) {
                return `${unitsSubUnitsArray[0]} kroner og ${unitsSubUnitsArray[1]} øre`;
            }
            return `${formattedNumber} kroner`;
        }

        return `${currency} ${formattedNumber}`;
    } catch {
        return value.toString();
    }
};

export const accessibileAccountNumber = (value: number | string): string => {
    const stringValue = typeof value === 'number' ? value.toString() : value;

    try {
        const integerGroups = stringValue.match(/\d+/g);

        if (integerGroups === null) {
            return stringValue;
        }

        return integerGroups.map((integersString) => integersString.split('').join(' ')).join(', ');
    } catch {
        return stringValue;
    }
};

export const createOwnersAriaLabel = (owners: AccountOwner[]): string => {
    const accountOwner = getRelevantOwner(owners);

    return !accountOwner ? '' : `Kontoeier, ${accountOwner}.`;
};

export const ariaLabelAccount = (account?: Account, label?: string) => {
    if (!account) {
        return `Velg ${label} Konto`;
    }

    const { owners, alias, balance, currency, accountNumber } = account;

    return `${label ?? ''} ${createOwnersAriaLabel(owners)} ${alias}, ${accessibleCurrency(
        balance.availableBalance,
        currency,
    )}, på konto ${accessibileAccountNumber(formatAccountNumber(accountNumber))}`;
};
